import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useTranslation } from "../../../localization/useTranslation";
import { useDeleteFrameworkControlDialogHooks } from "./DeleteFrameworkControlDialog.hooks";

export interface IDeleteFrameworkControlDialogProps {
    controlName: string;
    controlId: string;
    onDialogClose: () => void;
    onDeleted: () => void;
}

function DeleteFrameworkControlDialog(props: IDeleteFrameworkControlDialogProps) {
    const { translateString } = useTranslation();
    const { inProgess, removeFramework } = useDeleteFrameworkControlDialogHooks(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.controlName}
            onDialogClose={props.onDialogClose}
            onOkClick={removeFramework}
            inProgress={inProgess}
            additionalWarning={translateString("deleteFrameworkControlWarning")}
        />
    );
}

export default DeleteFrameworkControlDialog;
